<div class="kt-subheader__breadcrumbs">
    <a [routerLink]="['/']" class="kt-subheader__breadcrumbs-home">
        <em class="flaticon2-shelter"></em>
    </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <a [routerLink]="['/user/manage']" class="kt-subheader__breadcrumbs-link">
        Users </a>
    <span class="kt-subheader__breadcrumbs-separator"></span>
    <span>Detail</span>
</div>